export function useUrlParams(ids: string[]) {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValues: {[id: string]: string | null} = {};
  ids.forEach(id => {
    paramValues[id] = urlParams.get(id);
  });
  return paramValues;
}
